import ThirdraticEquationSolver from "./ThirdraticEquationSolver";
export default ThirdraticEquationSolver